import '.a{display:flex;}.ssr-plugin'
import '.e{align-items:center;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.bu{font-size:0.875rem;}.ssr-plugin'
import '.cb{color:var(--shades-gray-600);}.ssr-plugin'
import { Avatar, AvatarSize, AvatarShape } from '@app/components/core/avatar/Avatar'
import { styled } from 'inlines'

interface AuthorProps {
  avatarSrc?: string
  avatarSize?: AvatarSize
  avatarShape?: AvatarShape
  name: string
  description?: string
}

export const Author = ({
  avatarSrc,
  avatarSize = 'small',
  avatarShape = 'circle',
  name,
  description,
}: AuthorProps) => {
  return (
    <div className="a e al"
    >
      <Avatar size={avatarSize} image={avatarSrc} labelSource={name} shape={avatarShape} />

      <div>
        <styled.strong>{name}</styled.strong>
        <div className="bu cb"
        >
          {description}
        </div>
      </div>
    </div>
  )
}
